<template>
    <div class="policy_wrap">
        <div class="notes" style="font-family: 'OPPOSans-R', sans-serif;">
            <van-radio-group v-model="policy_checked">
                <van-radio v-model="policy_checked" name="1" shape="square"
                           :style="{'--radio-border-color': custom_col}" style="display: flex;align-items: center;">
                    <span :style="`color:${custom_col}`">报名即视为同意</span>
                    <span @click="policyDialogVisible = true"
                          :style="`color:${custom_col}`">《个人信息保护证明》</span>
                </van-radio>
            </van-radio-group>
        </div>

<!--        :append-to-body="true" 解决模版一造成的问题-->
        <el-dialog
            :visible.sync="policyDialogVisible"
            title="隐私政策"
            width="88%"
            class="policy_dialog"
            :center="true"
            :close-on-click-modal="false"
            custom-class="dialog_policy"
            :append-to-body="true"
        >
            <div class="policy_dialog_wrap">
                <h4>用户隐私权保护声明</h4>
                <div class="policy_dialog_subheading">
                    <p>（一）保护用户个人信息是易行汽车的一项基本原则。</p>
                    <ul>
                        <li>1. 保护用户个人信息是易行汽车的一项基本原则。易行汽车将按照本声明的规定收集、使用、储存和分享您的个人信息。</li>
                    </ul>
                </div>
                <div class="policy_dialog_subheading">
                    <p>（二）个人信息的收集。</p>
                    <ul>
                        <li>1. 我们收集您的个人信息的最终目的是为了向您提供更好的产品、服务，优化并丰富您的用户体验，这些个人信息是能够单独或者与其他信息结合识别您的个人身份的信息，包括:<br/>
                            <div class="policy_dialog_littleInfo">
                                <span>① 姓名</span>
                                <span>② 移动电话</span>
                                <span>③ 您在网站的表格上输入的其他信息（品牌、车型、车辆行驶证等）</span>
                                <span>④ 在您上载到网站的内容中包含的任何个人信息</span>
                            </div>
                        </li>
                        <li>
                            2. 以上个人信息均是您自愿提供。您有权拒绝提供，但如果您拒绝提供某些个人信息，您将可能无法使用我们提供的产品、服务，或者可能对您使用产品或服务造成一定的影响。
                        </li>
                        <li>
                            3. 对于不满 18 岁的用户，须在其法定监护人已经阅读本声明并且许可的情况下，通过网站提交个人信息。
                        </li>
                    </ul>
                </div>
                <div class="policy_dialog_subheading">
                    <p>（三）易行汽车保证在未经用户合法授权时，不对外公开或向第三方提供单个用户的注册信息及用户保存在易行汽车下属网站中的非公开内容，除非有下列情况：</p>
                    <ul>
                        <li>
                            1. 与国家安全、国防安全有关的；
                        </li>
                        <li>
                            2. 与公共安全、公共卫生、重大公共利益有关的；
                        </li>
                        <li>
                            3. 与犯罪侦查、起诉、审判和判决执行等有关的:
                        </li>
                        <li>
                            4. 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                        </li>
                        <li>
                            5. 所收集的个人信息是个人信息主体自行向社会公众公开的；
                        </li>
                        <li>
                            6. 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
                        </li>
                        <li>
                            7. 根据您的要求签订合同所必需的:
                        </li>
                        <li>
                            8. 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
                        </li>
                        <li>
                            9. 为合法的新闻报道所必需的；
                        </li>
                        <li>
                            10. 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
                        </li>
                        <li>
                            11. 法律法规规定的其他情形。您同意，易行汽车可以通过以下方式对个人信息进行使用和分享（包含对于个人信息的存储和处理）：
                            <div class="policy_dialog_littleInfo">
                                <span>① 我们和关联公司使用:</span>
                                <span>② 我们向相关有合作关系的汽车经销商、厂商及集团分享并由其使用；</span>
                                <span>③ 我们及关联公司及相关有合作关系的汽车经销商、厂商为满足您的需求，可能通过您提供的信息与您联系；</span>
                                <span>④ 我们及关联公司及相关有合作关系的汽车经销商、厂商可能定期或不定期向您发送有关产品、服务或相关活动的信息，您同意接收上述信息。</span>
                            </div>
                        </li>
                        <li>
                            您同意免除上述个人信息的接收和或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。
                        </li>
                    </ul>
                </div>
                <div class="policy_dialog_subheading">
                    <p>（四）本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。</p>
                </div>
                <div class="policy_dialog_subheading">
                    <p>（五）本网站相关声明版权及其修改权、更新权和最终解释权均属易行汽车所有。</p>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "policy",
        data(){
            return{
                policy_checked: false,
                policyDialogVisible: false,
            }
        },
        props: {
            custom_col: {
                default: '#3a8ee6'
            }
        },
        mounted() {
            console.log(this.custom_col, '颜色')
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/common/policy.less";
    /deep/ .van-radio__icon {
        font-size: 18px;
        line-height: normal;
    }
    /*变量控制*/
    /deep/ .van-radio__icon--square .van-icon {
        border-color: var(--radio-border-color);
        border-radius: 2px;
        // transform: translateY(-2px);
        // border: 0.5px solid var(--radio-border-color);
    }
</style>
<style lang="less">

    .policy_dialog{
        .el-dialog__body{
            padding: 10px 20px;
            padding-bottom: 20px;
            color: #666666;
            .policy_dialog_p{
                line-height: 27px;
            }
        }
        .el-dialog{
            border-radius: 10px;
            height: 66%;
            overflow-y: scroll;
            overflow-x: hidden;
            .el-dialog__title, .el-dialog__headerbtn .el-dialog__close{
                font-weight: bold;
            }
        }

    }
    .policy_dialog_wrap li, .policy_dialog_wrap p{
        line-height: 1.5;
        margin-bottom: 10px;
    }
    .el-checkbox{
        display: flex;
        align-items: center;
    }
    .el-checkbox__inner{
        width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        font-size: 14px;
    }
    .el-checkbox__inner::after {
        height: 5px;
        left: 4px;
        position: absolute;
        top: 2px;
        width: 2px;
    }
    .van-radio__label{
        margin-left: 6px;
        line-height: normal;
    }
</style>

